<div class="container-stteper">
  <div class="steps" [ngStyle]="steps.length < 3 ? { 'width': '60%' } : { 'width': '80%' }">
    @for (step of steps; track step) {
    <div class="step-item d-flex flex-column align-items-center">
      <div [ngClass]="step <= currentStep ? 'box-stepper-text-left' : 'box-stepper-text-right'">
        <span class="circle" [ngClass]="{
                  'circle-left': step < currentStep,
                  'circle-right': step >= currentStep,
                  'active': step === currentStep
                }"></span>
      </div>
      <div [ngClass]="step <= currentStep ? 'box-stepper-text-left' : 'box-stepper-text-right'">
        <span class="stepper-text" [ngClass]="{ 'active-text': step === currentStep }">
          PASO {{ step }}
        </span>
      </div>
    </div>
    }

    <div class="progress-bar">
      <span class="indicator" [ngStyle]="{ 'width': progress + '%' }"></span>
    </div>
  </div>
</div>